import { getSignedURLSByPathAPI } from '../http-clients/signed-url.client'
import { isValidFTSS3Bucket } from './utils'

export const getSignedOrPublicURL = async (url: string): Promise<string> => {
    if (!isValidFTSS3Bucket(url)) {
        return url
    }

    const resourceName = url.split('/').slice(3).join('/')
    if (resourceName.length === 0) {
        return ''
    }

    const resp = await getSignedURLSByPathAPI(resourceName)
    if (!resp.isOk()) {
        return ''
    }
    return resp.value.data[resourceName]?.download_url ?? ''
}

export const getSignedURLSByPath = async (urlOrPath: string): Promise<string> => {
    const isHttpUrl = /^https?:\/\//i.test(urlOrPath)

    if (isHttpUrl && !isValidFTSS3Bucket(urlOrPath)) {
        return urlOrPath
    }

    const resourceName = isHttpUrl
        ? urlOrPath.split('?')[0].split('/').slice(3).join('/')
        : urlOrPath.split('?')[0].replace(/^\/+/, '')
    if (resourceName.length === 0) {
        return ''
    }

    const resp = await getSignedURLSByPathAPI(resourceName)
    if (!resp.isOk()) {
        return ''
    }
    return resp.value.data[resourceName]?.download_url ?? ''
}
